// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-page {
  width: 100%;
  min-height: 100vh;
  height: auto;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
  background: #f5f5f5;
  margin: 0;
  overflow: hidden;
}

.chart-controls {
  display: flex;
  gap: 15px;
  align-items: center;
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.chart-controls button:first-of-type {
  margin-left: auto;
}

.chart-controls button + button {
  margin-left: 10px;
}

.control-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.control-group label {
  font-size: 12px;
  font-weight: 600;
  color: #555;
}

.control-group input,
.control-group select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  min-width: 120px;
}

.control-group input:focus,
.control-group select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
}

button {
  padding: 8px 16px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
}

button:hover:not(:disabled) {
  background: #0056b3;
}

button:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.chart-container {
  flex: 1 1;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  box-sizing: border-box;
  padding: 20px;
  position: relative;
  min-height: 400px;
  overflow: hidden;
  max-height: calc(100vh - 250px);
}

.loading, .no-data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: #666;
}

.loading {
  color: #007bff;
}

.no-data {
  color: #999;
}

/* 인쇄 스타일 */
@media print {
  @page { 
    size: A4 landscape; 
    margin: 20mm 10mm 10mm 10mm; /* 위, 오른쪽, 아래, 왼쪽 */ 
  }

  /* 브라우저 기본 여백 제거 */
  html, body, #root {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* 화면용 제한 해제 + 넘침 방지 */
  .chart-page {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    max-height: none !important;   /* <-- 이 줄이 중요 */
    overflow: visible !important;
  }

  /* 컨테이너는 인쇄 시 패딩/보더 제거(폭 넘침 원인 제거) */
  .chart-container {
    box-sizing: border-box;        /* 안전장치 */
    padding: 0 !important;
    border: 0 !important;          /* 기존에 border:1px 있었음 → 제거 */
    width: 100% !important;
    max-width: 100% !important;
    height: 180mm !important;      /* 필요에 따라 160~190mm 조절 */
    max-height: none !important;   /* 화면용 max-height 무력화 */
    overflow: visible !important;
  }

  /* 캔버스는 컨테이너에 딱 맞추기 */
  canvas {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
    max-width: 100% !important;
    page-break-inside: avoid;
  }

  /* 색상 인쇄 정확도 */
  body { print-color-adjust: exact; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ChartPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;AACX;EACE;IACE,kBAAkB;IAClB,2BAA2B,EAAE,mBAAmB;EAClD;;EAEA,kBAAkB;EAClB;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA,sBAAsB;EACtB;IACE,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B,IAAI,gBAAgB;IAC/C,4BAA4B;EAC9B;;EAEA,oCAAoC;EACpC;IACE,sBAAsB,SAAS,SAAS;IACxC,qBAAqB;IACrB,oBAAoB,WAAW,4BAA4B;IAC3D,sBAAsB;IACtB,0BAA0B;IAC1B,wBAAwB,OAAO,wBAAwB;IACvD,2BAA2B,IAAI,uBAAuB;IACtD,4BAA4B;EAC9B;;EAEA,qBAAqB;EACrB;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA,cAAc;EACd,OAA0C,yBAAyB,EAAE;AACvE","sourcesContent":[".chart-page {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  height: auto;\r\n  max-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 10px;\r\n  box-sizing: border-box;\r\n  background: #f5f5f5;\r\n  margin: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.chart-controls {\r\n  display: flex;\r\n  gap: 15px;\r\n  align-items: center;\r\n  background: white;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  margin-bottom: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.chart-controls button:first-of-type {\r\n  margin-left: auto;\r\n}\r\n\r\n.chart-controls button + button {\r\n  margin-left: 10px;\r\n}\r\n\r\n.control-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.control-group label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #555;\r\n}\r\n\r\n.control-group input,\r\n.control-group select {\r\n  padding: 8px 12px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  min-width: 120px;\r\n}\r\n\r\n.control-group input:focus,\r\n.control-group select:focus {\r\n  outline: none;\r\n  border-color: #007bff;\r\n  box-shadow: 0 0 0 2px rgba(0,123,255,0.25);\r\n}\r\n\r\nbutton {\r\n  padding: 8px 16px;\r\n  background: #007bff;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\nbutton:hover:not(:disabled) {\r\n  background: #0056b3;\r\n}\r\n\r\nbutton:disabled {\r\n  background: #6c757d;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.chart-container {\r\n  flex: 1;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  box-sizing: border-box;\r\n  padding: 20px;\r\n  position: relative;\r\n  min-height: 400px;\r\n  overflow: hidden;\r\n  max-height: calc(100vh - 250px);\r\n}\r\n\r\n.loading, .no-data {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  font-size: 16px;\r\n  color: #666;\r\n}\r\n\r\n.loading {\r\n  color: #007bff;\r\n}\r\n\r\n.no-data {\r\n  color: #999;\r\n}\r\n\r\n/* 인쇄 스타일 */\r\n@media print {\r\n  @page { \r\n    size: A4 landscape; \r\n    margin: 20mm 10mm 10mm 10mm; /* 위, 오른쪽, 아래, 왼쪽 */ \r\n  }\r\n\r\n  /* 브라우저 기본 여백 제거 */\r\n  html, body, #root {\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n  }\r\n\r\n  /* 화면용 제한 해제 + 넘침 방지 */\r\n  .chart-page {\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n    height: auto !important;\r\n    max-height: none !important;   /* <-- 이 줄이 중요 */\r\n    overflow: visible !important;\r\n  }\r\n\r\n  /* 컨테이너는 인쇄 시 패딩/보더 제거(폭 넘침 원인 제거) */\r\n  .chart-container {\r\n    box-sizing: border-box;        /* 안전장치 */\r\n    padding: 0 !important;\r\n    border: 0 !important;          /* 기존에 border:1px 있었음 → 제거 */\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n    height: 180mm !important;      /* 필요에 따라 160~190mm 조절 */\r\n    max-height: none !important;   /* 화면용 max-height 무력화 */\r\n    overflow: visible !important;\r\n  }\r\n\r\n  /* 캔버스는 컨테이너에 딱 맞추기 */\r\n  canvas {\r\n    display: block !important;\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    max-width: 100% !important;\r\n    page-break-inside: avoid;\r\n  }\r\n\r\n  /* 색상 인쇄 정확도 */\r\n  body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
